<template>
  <div class="m-b-50">
     
     <h3 class="m-b-20">{{ printerInkSet.printerName }}</h3>
     <b-row>
       <single-printer-ink-stock v-for="inkInfo in printerInkSet.inkData" :key="inkInfo.id" :stock-record="inkInfo"/>
     </b-row>

     
  </div>
</template>

<script>
const SinglePrinterInkStock = () => import(/* webpackChunkName: "stocks.single-printer-ink-stock" */ "./single-printer-ink-stock");


  export default {
    components: {SinglePrinterInkStock},
     props: {
       printerInkSet:{
         type: Object,
         default: () => ({})
       }
     }
  }
</script>

<style lang="scss" scoped>
  .single-set{
    padding: 15px;
  }
</style>